import { Color, Numeric } from "@siteimprove/alfa-css";
import { Style } from "../../style.js";
const sides = ["top", "right", "bottom", "left"];
/**
 * @public
 */
export function hasBorder(device, context) {
    return (element) => {
        const style = Style.from(element, device, context);
        return sides.some((side) => style.computed(`border-${side}-width`).none(Numeric.isZero) &&
            style
                .computed(`border-${side}-color`)
                .none((color) => color.type === "color" && Color.isTransparent(color)));
    };
}
//# sourceMappingURL=has-border.js.map